/**
 * Prop Scoring Adapter
 *
 * Transforms scoring question data into PropScoringQuestion component props
 */

import type { ScoringQuestionData } from '../types';

/**
 * PropScoringQuestion component props
 */
export interface PropScoringQuestionProps {
  questionText: string;
  questionSubtext?: string;
  questionNumber?: number;
  options: Array<{
    option_id?: string;
    option_text_en: string;
    option_text_fr?: string;
    option_image_en?: string | null;
    option_image_fr?: string | null;
    third_image_en?: string | null;
    third_image_fr?: string | null;
    is_correct: boolean;
    points?: number;
    selectionCount?: number;
    stats?: any;
    grading_data?: {
      playerId?: string | number;
      teamId?: string | number;
    };
  }>;
  points: number;
  status?: 'LIVE' | 'FINAL' | 'SCHEDULED';
  statTypeCode?: string | null;
}

/**
 * Transforms scoring data into PropScoringQuestion props
 *
 * @param data - Scoring question data
 * @returns PropScoringQuestion component props
 */
export function propScoringAdapter(data: ScoringQuestionData): PropScoringQuestionProps {
  return {
    questionText: data.questionText,
    questionSubtext: data.questionSubtext,
    questionNumber: data.questionNumber,
    options: data.options.map(opt => ({
      option_id: opt.option_id,
      option_text_en: opt.option_text_en,
      option_text_fr: opt.option_text_fr,
      option_image_en: opt.option_image_en,
      option_image_fr: opt.option_image_fr,
      third_image_en: opt.third_image_en,
      third_image_fr: opt.third_image_fr,
      is_correct: opt.is_correct,
      points: opt.points,
      selectionCount: opt.selectionCount,
      stats: opt.stats,
      grading_data: opt.grading_data
        ? {
            playerId: opt.grading_data.playerId,
            teamId: opt.grading_data.teamId,
          }
        : undefined,
    })),
    points: data.totalPoints,
    status: data.status,
    statTypeCode: data.statTypeCode,
  };
}
